import styled from "styled-components/macro";
import { SmileyStaticComponent } from "./SmileyStaticComponent";

interface EmotionLevelAndSmileyProps {
	emotionLevel: number;
}

export const EmotionLevelAndSmiley: React.FC<EmotionLevelAndSmileyProps> = ({ emotionLevel }) => {
	if (Math.round(emotionLevel) === 0) return <></>;
	return (
		<Container>
			<div>
				<SmileyStaticComponent emotionLevel={emotionLevel} size={16} />
			</div>
			<Score>{emotionLevel?.toFixed(1)}</Score>
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`;

const Score = styled.div`
	color: #262626;
	text-align: right;
	font-family: "Inter";
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 14px;
`;
